export const FETCH_PRODUCTS_REQUEST = 'FETCH_PRODUCTS_REQUEST'
export const FETCH_PRODUCTS_SUCCESSFUL = 'FETCH_PRODUCTS_SUCCESSFUL'
export const FETCH_PRODUCTS_ERROR = 'FETCH_PRODUCTS_ERROR'

export function fetchProducts(id, products) {
    return { type: FETCH_PRODUCTS_REQUEST, payload: { id, shopItems: products} }
}



// WEBPACK FOOTER //
// ./src/actions/products.js